import { gql } from "graphql-request";

export const BudgetFieldsFragment = gql`
  fragment BudgetFieldsFragment on BudgetSearchResult {
    budgetId
    name
    subdomain
  }
`;
